var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (direction, html) {
if ( direction < 0)
{
buf.push("<span class=\"sort-indicator glyphicon glyphicon-arrow-down\"></span>");
}
else if ( direction > 0)
{
buf.push("<span class=\"sort-indicator glyphicon glyphicon-arrow-up\"></span>");
}
buf.push(null == (jade_interp = html) ? "" : jade_interp);}.call(this,"direction" in locals_for_with?locals_for_with.direction:typeof direction!=="undefined"?direction:undefined,"html" in locals_for_with?locals_for_with.html:typeof html!=="undefined"?html:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/vnext/projection/sortable-header.jade
// module id = 89
// module chunks = 0